import React, { useEffect, useState } from 'react';
import { XGridDefaultColumn } from 'app/components/Common/XGrid/cells/XGridDefaults';
import { GridColumns, GridCellParams, GridValueSetterParams } from '@mui/x-data-grid-pro';
import { makeStyles } from 'tss-react/mui';
import { WhiteTooltip, XGridChipCell } from '@AMIEWEB/Common';
import { useDispatch, useSelector } from 'react-redux';
import { GridRowsProp } from '@mui/x-data-grid-pro';
import XGridTaskCell from './XGridTaskCell';
import {
  fetchDetailsforAddMod,
  getAmount,
  getColor,
  gridFilterRowCount,
  statusHandler,
  batchModResponseHandler
} from '../ModificationsUtils';
import { IXGridBulkActionButton } from '@AMIEWEB/Common/XGrid/Toolbar/XGridToolbar';
import AddIcon from '@mui/icons-material/Add';
import { selectPlacementStatus } from 'store/redux-store/placement-status/selectors';
import { sanitizeString } from '../ModificationsUtils';
import { formatDate } from '@AMIEWEB/Order/OrderDetails/helper';
import { getEndOfDate } from 'app/helpers/dateHelper';
import {
  Box,
  List,
  ListItemText,
  ListItemButton,
  CircularProgress,
  Grid,
  Popper,
  ClickAwayListener,
  Paper,
  Popover,
} from '@mui/material';
import {
  selectModSavedStatus,
  selectOpenTaskGridFromHistory,
  selectPendingModifications,
  selectPlacementModsList,
  selectRefreshPlacementMods,
  selectRefreshPlacementModsList,
  selectIsEmiLmoDisabled,
  selectOpenRefreshContractPayrollDialog,
  selectOpenRefreshContractPayrollConfirmDialog,
  selectRefreshContractPayrollResponse,
  selectRefreshContractPayrollSaveResponse
} from 'store/redux-store/placement-mods/selectors';
import { disablePlacementStatusOptions, disableRefreshContractPayroll } from '../CommonComponents/PlacementStatus';
import { useParams } from 'react-router-dom';
import { usePromiseTracker } from 'react-promise-tracker';
import { placementDetailsAction } from 'store/redux-store/placement-details/slice';
import {
  selectPlacementHeaderData,
  selectPlacementModificationTabRendered,
} from 'store/redux-store/placement-details/selectors';
import { missingField } from 'app/constants';
import { XGridOverflowCell } from '@AMIEWEB/Common/XGrid/cells/XGridOverflowCell';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import RestoreIcon from '@mui/icons-material/Restore';
import { isReadOnly, useReadOnly } from 'oidc/userRoles';
import { selectUser } from 'oidc/user.selectors';
import {
  ff_placement_pending_mods_approve_deny_buttons,
} from 'app/constants/FeatureFlags/Placement/Keys';
import { useDecision } from '@optimizely/react-sdk';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { XGridClickableCell } from './XGridClickableCell';
import { GridState } from '@mui/x-data-grid';
import { LinkTaskForMods } from './LinkTaskForMods';
import { ReplaceTasks } from '../CommonComponents/ReplaceTasks/ReplaceTasks';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { UnLinkTasks } from '../CommonComponents/UnLinkTasks/UnLinkTasks';
import { disabledRefreshPlacementStatus } from '../CommonComponents/RefreshPlacementStatus';
import { UnableRefresh } from '@AMIEWEB/Common/UnableRefreshModal/Unablerefresh';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import { RefreshContractPayrollModal } from './RefreshContractPayrollModal';
import { useTranslation } from 'react-i18next';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { BookingApprovedCheckbox } from './BookingApprovedCheckbox';
import { ApproveModActions } from './ApproveModActions';
import { gridSelectionActions } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.redux';
import { XGridInlineEdit } from 'app/components/Common/XGrid/XGridInlineEdit';
import { Authorized } from 'oidc/userHelper';
import { isClientContractAdminUser, userRoles } from 'oidc/userRoles';
import { ApprovalStatus, AcceptenceStatus } from 'app/models/Placement/PlacementMods';
import { PromiseTrackerKeys } from 'app/constants/PromiseTrackerKeys';
import { GridType } from 'app/components/Common/types';
import { isRecruitmentUser } from 'oidc/userRoles';
import { Brand } from 'app/components/Placement/PlacementDetails/PlacementDetailsHeader/utils';
import { selectUserPreference } from 'oidc/UserDevicePreference/userPreference.selectors';
import { userDevicePreferenceActions } from 'oidc/UserDevicePreference/userPreference.redux';
import { RootState } from 'types';
import { gridTags, MODIFICATIONS_GRID_PAGE_SIZE } from 'app/models/Placement/PlacementMods';
import { GridColumns as CurrentGridColumns } from 'app/models/GlobalSearch/GlobalSearch';
import { GridColumns as XGridColumns } from '@mui/x-data-grid-pro';
import { GridColumnVisibilityModel, GridPinnedColumns, GridDensity, GridFilterModel } from '@mui/x-data-grid-pro';
import _ from 'lodash';
import { usePinnedColumnsPreference, useSortModelPreference, useGetSortModelPreferences } from 'app/components/Common/XGrid/Hooks';
import { generateSafeId } from 'app/helpers/objectHelpers';

const useStyles = makeStyles()(theme => ({
  grid: {
    fontSize: '14px',
  },
  validationLoader: {
    left: 'calc(50% - 20px)',
    top: '50%',
    position: 'absolute',
  },
  paper: {
    width: '250px',
    overflowX: 'hidden',
    overflowY: 'auto',
    boxShadow: '2px 5px 10px #0000004D',
  },
  popperPaper: {
    maxHeight: `${50}vh`,
  },
  listItem: {
    '& .MuiListItem-root': {
      padding: '0 20px',
      paddingLeft: 8,
    },
    '& .MuiListItemButton-root': {
      padding: '0 16px',
      paddingLeft: 8,
    },
    '& .MuiButtonBase-root': {
      padding: '0 20px',
    },
  },
  whiteSpace: {
    whiteSpace: 'pre',
  },
  voidedCell: {
    backgroundColor: theme.palette.framework.system.backgroundGrey,
  },
}));

// Default visibility model for Pending Modifications grid
const PendingModificationsVisibilityModel = {
  type: true,
  description: true,
  standard: true,
  amount: true,
  acceptance: true,
  effectiveDate: true,
  status: true,
  task: true,
  recruiterApproved: true,
  byRecruiter: true,
  lastUpdated: true,
};

const isDisabled = currentPlacementStatus => {
  return (
    currentPlacementStatus &&
    disablePlacementStatusOptions.some(
      x =>
        x.activityStatusId === currentPlacementStatus?.activityStatusId &&
        x.activityTypeId === currentPlacementStatus?.activityTypeId,
    )
  );
};

const PendingModifications = ({
  onModsDetailsClick,
  setModsDialogDetails,
}: {
  onModsDetailsClick: any;
  setModsDialogDetails: any;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [rowsToDisplay, setRowsToDisplay] = useState([]);
  const { classes } = useStyles();
  const pendingMods = useSelector(selectPendingModifications);
  const isEmiLmoDisabled = useSelector(selectIsEmiLmoDisabled);
  const [selectedRowDetails, setSelectedRowDetails] = useState([]);
  const gridTag = gridTags.MODS_PENDING_GRIDTAG;
  
  const getRowClassName = (params) => {
    return params.row.voidStatus === 'Y' ? classes.voidedCell : '';
  };

  const [columns, setColumns] = useState<any>([]);
  const params = useParams<{ placementId: string }>();
  const [sortedColumn, setSortedColumn] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const { promiseInProgress: isCallingAPI } = usePromiseTracker({ area: PromiseTrackerKeys.placements.getModifications, delay: 0 });
  const { promiseInProgress: isSavingMods } = usePromiseTracker({ area: PromiseTrackerKeys.placements.bulkUpdateMods, delay: 0 });
  const { promiseInProgress: isDeletingMods } = usePromiseTracker({ area: PromiseTrackerKeys.placements.bulkDeleteMods, delay: 0 });
  
  // Combine all saving states
  const isSavingInProgress = isSavingMods || isDeletingMods;
  const modItems = useSelector(selectPlacementModsList);
  const refreshModItems = useSelector(selectRefreshPlacementModsList);
  const modSavedResponse = useSelector(selectModSavedStatus);
  const { currentPlacementStatus } = useSelector(selectPlacementStatus);
  const tabRendered = useSelector(selectPlacementModificationTabRendered);
  const [totalCount, setTotalCount] = useState<number>(0);
  const placementDetails = useSelector(selectPlacementHeaderData);
  const { readOnly } = useReadOnly();

  const [
    { headerHeight, borderWidth, toolbarHeight, scrollBarWidth, rowHeight, gridMaxHeight, maxCount, initialPageSize },
  ] = React.useState({
    headerHeight: 70,
    borderWidth: 2,
    toolbarHeight: 10,
    scrollBarWidth: 12,
    rowHeight: 36,
    gridMaxHeight: 50 * 36,
    maxCount: 50,
    initialPageSize: MODIFICATIONS_GRID_PAGE_SIZE,
  });
  const gridMinHeight = React.useMemo(
    () => (rowsToDisplay.length > 0 && rowsToDisplay.length < maxCount ? rowsToDisplay.length * rowHeight : 200),
    [maxCount, rowHeight, rowsToDisplay.length],
  );
  const [gridHeight, setGridHeight] = useState<number>(gridMinHeight);
  const appUser = useSelector(selectUser);
  const { openRefreshDialog, refreshModMessage } = useSelector(selectRefreshPlacementMods);
  const openRefreshContractPayrollDialog = useSelector(selectOpenRefreshContractPayrollDialog);
  const openRefreshContractPayrollConfirmDialog = useSelector(selectOpenRefreshContractPayrollConfirmDialog);
  const refreshContractPayrollResponse = useSelector(selectRefreshContractPayrollResponse);
  const refreshContractPayrollSaveResponse = useSelector(selectRefreshContractPayrollSaveResponse);
  const [addIconDisable, setAddIconDisable] = useState(true);
  const [approveDenyBtnFlag] = useDecision(ff_placement_pending_mods_approve_deny_buttons);
  const [openTaskGrid, setOpenTaskGrid] = useState(false);
  const [openReplaceTasks, setOpenReplaceTasks] = useState(false);
  const [openUnlink, setOpenUnlink] = useState(false);
  const openTaskFromHistory = useSelector(selectOpenTaskGridFromHistory);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [popoverHeight, setPopoverHeight] = useState(0);
  const [xgridMinHeight, setXgridMinHeight] = useState<number>(gridMinHeight);
  const userPreference = useSelector(selectUserPreference);
  const gridPreferences = useSelector((state: RootState) => {
    return state.userPreferenceData.userGridPreferences.find(item => item.id === gridTag);
  });
  const [currentColumnVisibilityModel, setCurrentColumnVisibilityModel] = React.useState<any>({});
  const [pinnedColumns, setPinnedColumns] = React.useState<GridPinnedColumns>({});
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({ items: [] });
  const [density, setDensity] = React.useState<GridDensity>('compact');
  const [showResetButton, setShowResetButton] = React.useState<boolean>(false);
  const expectedResetVisibilityModelRef = React.useRef<GridColumnVisibilityModel | null>(null);
  


  const getAvailableHeightForPopOver = React.useCallback(() => {
    setPopoverHeight(
      window.innerHeight - document.getElementById('addIconPendingModification').getBoundingClientRect().top - 100,
    );
  }, []);

  const getApprovalStatusOptions = React.useCallback((currentModDetails) => {
    let approvalOptions = [];
    const modName = currentModDetails.type?.replaceAll(/['/.\s]/g, '');
    const isEndDateMod = modName === 'EndDate';
    
    // Build base approval options from the row's approvalOptions
    const baseApprovalOptions = ['Pending', 'Approved', 'Denied', 'Recruiter Approved'];
    const currentApprovalStatusOptions = currentModDetails.approvalStatusOptions;
    
    if (currentApprovalStatusOptions) {
      approvalOptions = currentApprovalStatusOptions.map(option => option.value);
    } else {
      // Fallback to default options if no specific options provided
      approvalOptions.push(...baseApprovalOptions);
    }

    // Apply business rules based on user roles and modification context
    
    // Rule 1: Non-authorized users with pending status for certain mod types
    if (
      !Authorized(
        [userRoles.candidate_Contracts_Leadership, userRoles.candidate_Contracts_TeamMember],
        appUser?.userInfo,
      ) &&
      currentModDetails?.approvalStatusId === ApprovalStatus.Pending &&
      !isEndDateMod &&
      modName !== 'BillRate' &&
      modName !== 'BillingShiftDifferential'
    ) {
      approvalOptions = [];
    } else if (
      // Rule 2: Timeoff mod restrictions
      modName === 'Timeoff' &&
      currentModDetails?.isBookingApprovedOrGreater === false &&
      (currentModDetails?.approvalStatusId === ApprovalStatus.Approved || 
       currentModDetails?.approvalStatusId === ApprovalStatus.Denied)
    ) {
      approvalOptions = [];
    } else if (
    // Rule 3: Shift/Preferences mod restrictions for approved status
      (modName === 'Shift' || modName === 'Preferences') &&
      currentModDetails?.isBookingApprovedOrGreater === false &&
      currentModDetails?.approvalStatusId === ApprovalStatus.Approved
    ) {
      approvalOptions = approvalOptions.filter(val => val === 'Approved');
    } else if (
    // Rule 4: Shift/Preferences mod restrictions for denied status
      (modName === 'Shift' || modName === 'Preferences') &&
      currentModDetails?.isBookingApprovedOrGreater === false &&
      currentModDetails?.approvalStatusId === ApprovalStatus.Denied
    ) {
      approvalOptions = approvalOptions.filter(val => val === 'Denied');
    } else if (modName === 'BillRate' || modName === 'BillingShiftDifferential') {
    // Rule 5: BillRate/BillingShiftDifferential restrictions
      if (isClientContractAdminUser(appUser?.userInfo?.roles || [])) {
        approvalOptions = approvalOptions.filter(val => val !== 'Recruiter Approved');
      } else {
        approvalOptions = [];
      }
    } else if (
    // Rule 6: Booking not approved and user not authorized with specific approval statuses
      currentModDetails.isBookingApprovedOrGreater === false &&
      !Authorized(
        [userRoles.candidate_Contracts_Leadership, userRoles.candidate_Contracts_TeamMember],
        appUser?.userInfo,
      ) &&
      currentModDetails?.approvalStatusId !== ApprovalStatus.RecruiterApproved &&
      currentModDetails?.approvalStatusId !== ApprovalStatus.Pending
    ) {
      approvalOptions = approvalOptions.filter(val => val === 'Pending');
    } else if (
    // Rule 7: End date mod with recruitment user and specific brand for pending status
      isEndDateMod &&
      isRecruitmentUser(appUser?.userInfo?.roles || []) &&
      placementDetails?.brandId === Brand.AMN_Labor_Disruption &&
      currentModDetails?.approvalStatusId === ApprovalStatus.Pending
    ) {
      approvalOptions = approvalOptions.filter(val => val !== 'Recruiter Approved');
    } else if (
    // Rule 8: End date mod with recruitment user for pending status (general case)
      isEndDateMod &&
      isRecruitmentUser(appUser?.userInfo?.roles || []) &&
      placementDetails?.brandId !== Brand.AMN_Labor_Disruption &&
      currentModDetails?.approvalStatusId === ApprovalStatus.Pending
    ) {
      approvalOptions = approvalOptions.filter(val => val === 'Recruiter Approved');
    } else if (
    // Rule 9: Authorized users who are not in Recruitment shouldnot have Recruiter Approved option 
      Authorized(
        [userRoles.candidate_Contracts_Leadership, userRoles.candidate_Contracts_TeamMember],
        appUser?.userInfo,
      )
    ) {
        approvalOptions = approvalOptions.filter(val => val !== 'Recruiter Approved');
    } else if (
    // Rule 10: End date mod with recruiter approved status and recruitment user
      isEndDateMod &&
      currentModDetails?.approvalStatusId === ApprovalStatus.RecruiterApproved &&
      isRecruitmentUser(appUser?.userInfo?.roles || [])
    ) {
      approvalOptions = approvalOptions.filter(val => val === 'Denied');
    } else if (
      // Rule 11: End date mod and not a recruitment user
      isEndDateMod &&
      !isRecruitmentUser(appUser?.userInfo?.roles || [])
    ) {
      approvalOptions = [];
    }

    return [currentModDetails.descApprovalStatus, ...approvalOptions];

  }, [appUser, placementDetails]);

  const updateApprovalStatusOptions = (rowsToModify) => (
    rowsToModify.map(rowToModify => {
      const approvalOptions = getApprovalStatusOptions(rowToModify);

      return {
        ...rowToModify,
        approvalStatusOptions: approvalOptions
      };
    })
  );

  const isCellEditable = React.useCallback((params: any, cellName: string) => {
    let isEditable = false;
    const selectRowDetail = selectedRowDetails.find(row => row.id === params.id);

    if (selectRowDetail?.id && cellName === 'effectiveDate') {
      isEditable = !getReadOnlyStatus(selectRowDetail)
    } else if (selectRowDetail?.id && cellName === 'acceptanceStatus') {
      isEditable = !isEmiLmoDisabled;
    } else if (selectRowDetail?.id && cellName === 'approvalStatus') {
      isEditable = !isApprovalDisabledWhenLessThanBooking(selectRowDetail) &&
      selectRowDetail.approvalStatusOptions.length > 1
    }

    return isEditable;

  }, [selectedRowDetails, isEmiLmoDisabled]);

  const calcGridHeight = React.useCallback(
    (rows: number) => {
      if (rows >= maxCount) {
        setGridHeight(gridMaxHeight);
      } else if (rows > 0 && rows < maxCount) {
        const height = borderWidth + headerHeight + toolbarHeight + scrollBarWidth + rowHeight * rows;
        setGridHeight(gridMinHeight >= height ? gridMinHeight : height);
        setXgridMinHeight(gridMinHeight >= height ? gridMinHeight : height);
      } else {
        setGridHeight(200);
        setXgridMinHeight(200);
      }
    },
    [borderWidth, gridMaxHeight, gridMinHeight, headerHeight, maxCount, rowHeight, scrollBarWidth, toolbarHeight],
  );

  const isRefreshIconDisabled = React.useMemo(() => {
    return (
      currentPlacementStatus &&
      disabledRefreshPlacementStatus.some(
        x =>
          x.activityStatusId === currentPlacementStatus?.activityStatusId &&
          x.activityStatus === currentPlacementStatus?.activityStatus,
      )
    );
  }, [currentPlacementStatus]);

  const isRefreshContractPayrollDisabled = React.useMemo(() => {
    return (
      currentPlacementStatus &&
      disableRefreshContractPayroll.some(
        x =>
          x.activityStatusId === currentPlacementStatus?.activityStatusId &&
          x.activityTypeId === currentPlacementStatus?.activityTypeId,
      )
    );
  }, [currentPlacementStatus]);

  const onRowsSelectionHandler = React.useCallback(
    ids => {
      const selectedRows = rowsToDisplay?.filter(val => ids.includes(val.id));
      const updatedSelectedRows = selectedRows.length ? updateApprovalStatusOptions(selectedRows) : selectedRows;
      setRowSelectionModel(ids);
      setSelectedRowDetails(updatedSelectedRows);
    },
    [rowsToDisplay],
  );

  const [optionMenuAncorEl, setOptionMenuAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [refreshOptsAnchorEl, setRefreshOptsAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleTaskGridOpen = React.useCallback(() => {
    const isExisting = selectedRowDetails?.some(arr => arr.task);
    if (isExisting) setOpenReplaceTasks(true);
    else dispatch(placementModsAction.setOpenTaskGrid(selectedRowDetails));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowDetails]);

  const handleDeleteMod = React.useCallback(() => {
    const travelerOptionIds = [];
    const travelerOptionTimestamps = [];

    selectedRowDetails.forEach(selectedRow => {
      travelerOptionIds.push(selectedRow.travelerOptionId);
      travelerOptionTimestamps.push(selectedRow.travelerOptionTimestamp)
    });

    dispatch(
      placementModsAction.business_batchDeletePlacementMod({
        placementId: selectedRowDetails?.[0]?.placementId,
        travelerOptionIds: sanitizeString(travelerOptionIds.toString()),
        travelerOptionTimestamps: sanitizeString(travelerOptionTimestamps.toString())
      }),
    );
  }, [selectedRowDetails]);

  const handleRefreshContractAndPayroll = React.useCallback(() => {
    // Prevent action if saving is in progress
    if (isSavingInProgress) return;
    
    // Call API to check if there's a new payroll and/or contract
    dispatch(placementModsAction.checkRefreshContractPayroll({
      placementId: parseInt(params.placementId)
    }));
  }, [isSavingInProgress, params.placementId, dispatch]);

  const handleCloseRefreshContractPayrollDialog = React.useCallback(() => {
    dispatch(placementModsAction.setOpenRefreshContractPayrollDialog(false));
  }, [dispatch]);

  const handleCloseRefreshContractPayrollConfirmDialog = React.useCallback(() => {
    dispatch(placementModsAction.setOpenRefreshContractPayrollConfirmDialog(false));
  }, [dispatch]);

  const handleConfirmRefreshContractPayroll = React.useCallback(() => {
    // Call API to save the changes
    dispatch(placementModsAction.saveRefreshContractPayroll({
      placementId: parseInt(params.placementId)
    }));
    dispatch(placementModsAction.setOpenRefreshContractPayrollConfirmDialog(false));
  }, [params.placementId, dispatch]);

  // Handle API response for check refresh contract and payroll
  useEffect(() => {
    if (refreshContractPayrollResponse) {
      const { hasChanges } = refreshContractPayrollResponse;
      
      if (hasChanges) {
        // Show confirmation dialog
        dispatch(placementModsAction.setOpenRefreshContractPayrollConfirmDialog(true));
      } else {
        // Show unable to refresh dialog
        dispatch(placementModsAction.setOpenRefreshContractPayrollDialog(true));
      }
      
      // Reset response after handling
      dispatch(placementModsAction.setRefreshContractPayrollResponse(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshContractPayrollResponse]);

  // Handle save response for refresh contract and payroll
  useEffect(() => {
    if (refreshContractPayrollSaveResponse) {
      // Check if responseCode is 0 for success (0 = Change applied successfully)
      const isSuccess = refreshContractPayrollSaveResponse.responseCode === 0;
      
      if (isSuccess) {
        // Show success snackbar
        dispatch(
          globalActions.setSnackBar({
            message: t('placement.placementMods.pendingMods.refreshContractPayrollModal.successMessage'),
            severity: 'success',
          }),
        );
      } else {
        // Show error snackbar - use existing error message pattern
        dispatch(
          globalActions.setSnackBar({
            message: refreshContractPayrollSaveResponse.message || t('placement.placementMods.pendingMods.refreshContractPayrollModal.errorMessage'),
            severity: 'error',
          }),
        );
      }
      
      // Reset response after handling
      dispatch(placementModsAction.setRefreshContractPayrollSaveResponse(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshContractPayrollSaveResponse, dispatch, t]);

  const handleAddClose = () => {
    setOptionMenuAnchorEl(null);
    setRefreshOptsAnchorEl(null);
  };

  useEffect(() => {
    if (openTaskFromHistory?.length > 0) {
      setOpenTaskGrid(true);
      setSelectedRowDetails(updateApprovalStatusOptions(openTaskFromHistory));
    }
  }, [openTaskFromHistory]);

   // Initial column setup - only run once when component mounts
   useEffect(() => {
    if (columns.length === 0) {
      setColumns(pendingModcolumns(onModsDetailsClick, t, []));
    }
  }, [onModsDetailsClick]);

   // Update columns with current selectedRowDetails for dynamic options
   useEffect(() => {
    if (columns.length > 0 && selectedRowDetails.length > 0) {
      // Update only the status column's valueOptions without changing column order
      const updatedColumns = columns.map(column => {
        if (column.field === 'status') {
          return {
            ...column,
            valueOptions: (params) => {
              const selectRowDetail = selectedRowDetails.find(row => row.id === params.id);
              return (selectRowDetail?.approvalStatusOptions ?? []);
            }
          };
        }
        return column;
      });
      setColumns(updatedColumns);
    }
  }, [selectedRowDetails, columns.length]);

  const getemilmodisabled = React.useCallback(
    item =>
      item.description === 'EMI/LMO' && (!placementDetails?.placementStartDate || !placementDetails?.placementEndDate),
    [placementDetails?.placementEndDate, placementDetails?.placementStartDate],
  );

  const handleOptClick = React.useCallback(
    item => {
      // Prevent action if saving is in progress
      if (isSavingInProgress) return;
      
      dispatch(placementModsAction.setOpenModForAdding({ isOpen: true, selectedMod: item.description }));
      setModsDialogDetails({ isOpen: true, selectedMod: item.description });
      dispatch(placementModsAction.setIsModEdit(true));
      fetchDetailsforAddMod(item, params.placementId, dispatch);
      handleAddClose();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [params.placementId, isSavingInProgress],
  );

  const optionsList = React.useMemo(
    () => (
      <List>
        {isCallingAPI || isSavingInProgress ? (
          <Grid item xs={12} style={{ minHeight: '10rem' }}>
            <CircularProgress className={classes.validationLoader} />
          </Grid>
        ) : (
          (modItems || []).map(item =>
            getemilmodisabled(item) ? (
              <WhiteTooltip title={t('placement.placementMods.emiLmoDisabledDueToMissingDateMessage')} key={item.id}>
                <span>
                  <ListItemButton
                    key={item.id}
                    className={classes.listItem}
                    disabled={true}
                    onClick={() => handleOptClick(item)}
                  >
                    <ListItemText primary={item.description} />
                  </ListItemButton>
                </span>
              </WhiteTooltip>
            ) : (
              <ListItemButton 
                key={item.id} 
                className={classes.listItem} 
                disabled={isSavingInProgress}
                onClick={() => handleOptClick(item)}
              >
                <ListItemText primary={item.description} />
              </ListItemButton>
            ),
          )
        )}
      </List>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getemilmodisabled, isCallingAPI, modItems, params.placementId, isSavingInProgress],
  );

  const refreshOpts = React.useCallback((currentMod, placementId) => {
    // Prevent action if saving is in progress
    if (isSavingInProgress) return;
    
    if (currentMod.id) {
      dispatch(
        placementModsAction.refreshModDetails({
          placementId: placementId,
          travelerOptionTypeId: currentMod.id,
        }),
      );
    }
    handleAddClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSavingInProgress]);

  const refreshOptionsList = React.useMemo(
    () => (
      <List>
        {isCallingAPI || isSavingInProgress ? (
          <Grid item xs={12} style={{ minHeight: '10rem' }}>
            <CircularProgress className={classes.validationLoader} />
          </Grid>
        ) : (
          (refreshModItems || []).map(item =>
            getemilmodisabled(item) ? (
              <WhiteTooltip title={t('placement.placementMods.emiLmoDisabledDueToMissingDateMessage')} key={item.id}>
                <span>
                  <ListItemButton
                    key={item.id}
                    className={classes.listItem}
                    disabled={true}
                    onClick={() => refreshOpts(item, params.placementId)}
                  >
                    <ListItemText primary={item.description} />
                  </ListItemButton>
                </span>
              </WhiteTooltip>
            ) : (
              <ListItemButton
                key={item.id}
                className={classes.listItem}
                disabled={isSavingInProgress}
                onClick={() => refreshOpts(item, params.placementId)}
              >
                <ListItemText primary={item.description} />
              </ListItemButton>
            ),
          )
        )}
      </List>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getemilmodisabled, isCallingAPI, params.placementId, refreshModItems, refreshOpts, isSavingInProgress],
  );

  useEffect(() => {
    if (isReadOnly(appUser?.userInfo?.roles || [])) {
      setAddIconDisable(true);
    } else {
      setAddIconDisable(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const leftActions = React.useMemo<IXGridBulkActionButton[]>(
    () => [
      // @ts-ignore
      {
        KeyId: 'booking-approved-checkbox',
        renderer: () => <BookingApprovedCheckbox />,
      },
      // @ts-ignore
      {
        KeyId: 'approved-mod-action',
        leftDivider: approveDenyBtnFlag.enabled ? true : false,
        renderer: () => approveDenyBtnFlag.enabled && <ApproveModActions />,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [approveDenyBtnFlag.enabled],
  );

  const actions = [
    {
      KeyId: 'add-preference-key',
      id: 'addIconPendingModification',
      Icon: AddIcon,
      onClick: (event: any) => {
        setOptionMenuAnchorEl(event.currentTarget);
        getAvailableHeightForPopOver();
      },
      disabled: isDisabled(currentPlacementStatus) || isSavingInProgress || readOnly,
      tooltipProps: {
        tooltipContent: t('placement.placementMods.pendingMods.addNewMod'),
      },
    },
    {
      KeyId: 'create-add-new-task',
      Icon: TaskAltIcon,
      onClick: () => {},
      disabled: true,
      tooltipProps: {
        tooltipContent: t('placement.placementMods.pendingMods.createNewTask'),
        classes: { tooltip: classes.whiteSpace },
      },
    },
    {
      KeyId: 'add-link-mod',
      Icon: LinkIcon,
      onClick: handleTaskGridOpen,
      disabled: selectedRowDetails?.length === 0 || isSavingInProgress || readOnly,
      tooltipProps: {
        tooltipContent: t('placement.placementMods.pendingMods.linkTask'),
      },
    },
    {
      KeyId: 'un-link-mod',
      Icon: LinkOffIcon,
      onClick: () => setOpenUnlink(true),
      disabled: selectedRowDetails?.length === 0 || !selectedRowDetails?.some(e => e.task) || isSavingInProgress || readOnly,
      tooltipProps: {
        tooltipContent: t('placement.placementMods.pendingMods.unLinkTask'),
      },
    },
    {
      KeyId: 'refresh-preference-key',
      Icon: AutorenewIcon,
      onClick: e => setRefreshOptsAnchorEl(e.currentTarget),
      disabled: isRefreshIconDisabled || isSavingInProgress || readOnly,
      tooltipProps: {
        tooltipContent: isRefreshIconDisabled
          ? t('placement.placementMods.pendingMods.disabledDueToStatus')
          : t('placement.placementMods.pendingMods.refreshMod'),
      },
    },
    {
      KeyId: 'delete-mod',
      Icon: DeleteOutlinedIcon,
      onClick: handleDeleteMod,
      disabled: selectedRowDetails?.length === 0 || isSavingInProgress || readOnly,
      tooltipProps: {
        tooltipContent: t('placement.placementMods.pendingMods.deleteMod')
      },
    },
    {
      KeyId: 'refresh-contract-payroll',
      Icon: RestoreIcon,
      onClick: handleRefreshContractAndPayroll,
      disabled: isRefreshContractPayrollDisabled || isSavingInProgress || readOnly,
      tooltipProps: {
        tooltipContent: isRefreshContractPayrollDisabled
          ? t('placement.placementMods.pendingMods.disabledDueToStatus')
          : t('placement.placementMods.pendingMods.refreshContractPayroll')
      },
    },
  ];

  const rightActions = React.useMemo<IXGridBulkActionButton[]>(() => {
    
    if (!addIconDisable) {
      return actions;
    } else {
      return actions.filter(val => val.KeyId !== 'add-preference-key');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ currentPlacementStatus, handleTaskGridOpen, handleRefreshContractAndPayroll, selectedRowDetails, addIconDisable, isSavingInProgress,readOnly]);

  const handleEmptyField = (param: any) => {
    return param ? param : missingField;
  };

  const formatPendingTableData = (rows: any) => {
    let mappedData = rows.map((item, index) => ({
      ...item,
      totalCount: item.totalCount,
      id: generateSafeId(),
      travelerOptionId: item.travelerOptionId ? item.travelerOptionId : 0,
      type: handleEmptyField(item.descTravelerOptionType),
      description: handleEmptyField(item.description),
      amount: item.amount,
      assignTaskId: item.assignTaskId,
      acceptance: handleEmptyField(item.descAcceptanceStatus),
      effectiveDate: item.effectiveDate ? formatDate(new Date(item.effectiveDate)) : missingField,
      status: statusHandler(item.approvalStatusId),
      task: item.hasAssignedTask === 'Y' ? true : false,
      recruiterApproved: item.recruiterApprovalDate
        ? formatDate(item.recruiterApprovalDate, 'dateAnd12HourTime')
        : missingField,
      byRecruiter: handleEmptyField(item.recruiterApprovedByName),
      lastUpdated: item.lastUpdated ? item.lastUpdated : missingField,
      standard: handleEmptyField(item.standard),
    }));
    if (mappedData && mappedData.length > 0) {
      setTotalCount(mappedData[0].totalCount);
    } else {
      setTotalCount(0);
    }
    return mappedData;
  };

  const loadServerRows = (request: any = {}) => {
    
    const payload = {
      pageNumber: 1,
      pageSize: initialPageSize,
      placementId: Number(params.placementId),
      offSet: 0,
      gridType: GridType.modification,
      sortColumn: null,
      sortOrder: null,
      ...request,
    };

    dispatch(placementModsAction.getModificationAction(payload));
  };

  const sortChangeHandelr = model => {
    setSortedColumn(model);
    setPageNumber(1);
    saveSortModel(model);
  };

  const refreshGrid = () => {
    dispatch(placementModsAction.setPendingMods([]));
    setPageNumber(1);
    loadServerRows();
  };

  const saveUnlinkMods = () => {
    const payload = {
      assignTaskId: null,
      assignRootTaskId: null,
      placementId: parseInt(params.placementId),
      travelerOptionIds: selectedRowDetails?.map(val => val?.travelerOptionId),
    };

    dispatch(placementModsAction.updateLinkModTask(payload));
  };

  useEffect(() => {
    if (!tabRendered) {
      dispatch(placementDetailsAction.setModificationTabRendered(true));
    }

    dispatch(placementModsAction.getBookingApprovedCheckboxSpecs({ placementId: parseInt(params.placementId) }));

    // Cleanup function when component unmounts
    return () => {
      dispatch(placementDetailsAction.setModificationTabRendered(false));
      dispatch(placementModsAction.setPendingMods([])); // Clear stored mods
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pendingMods && pendingMods.length > 0) {
      const mappedData = [...formatPendingTableData(pendingMods)];

      setRowsToDisplay(mappedData);
    } else {
      if (pageNumber === 1) {
        setRowsToDisplay([]);
        setTotalCount(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingMods]);

  useEffect(() => {
    calcGridHeight(rowsToDisplay.length);
    setSelectedRowDetails([]);
    setRowSelectionModel([]);
    dispatch(
      gridSelectionActions.setGridSelections({
        selectedData: [],
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsToDisplay]);

  const filterRowCount = (state: GridState) => {
    calcGridHeight(gridFilterRowCount(state));
  };

  const handleCancelChanges = React.useCallback(() => {
    setSelectedRowDetails([]);
    setRowSelectionModel([]);
    dispatch(
      gridSelectionActions.setGridSelections({
        selectedData: [],
      }),
    );
  }, [dispatch]);

  const handleSaveChanges = React.useCallback((newRows: GridRowsProp) => {
    const {
      userInfo: { employeeId },
    } = appUser;

    const modifications = [];

    // Instead of filtering by selectedRowDetails, find rows that have actually changed
    // by comparing with the original rowsToDisplay data
    const updatedRows = newRows?.filter(newRow => {
      // Find the original row data to compare against
      const originalRow = rowsToDisplay?.find(row => row.id === newRow.id);
      if (!originalRow) return false;

      // Check if any editable fields have changed
      const hasEffectiveDateChanged = newRow.effectiveDate !== originalRow.effectiveDate;
      const hasAcceptanceChanged = newRow.acceptance !== originalRow.acceptance;
      const hasStatusChanged = newRow.status !== originalRow.status;

      return hasEffectiveDateChanged || hasAcceptanceChanged || hasStatusChanged;
    });

    if(updatedRows.length > 0) {
      updatedRows.map(updatedRow => modifications.push({
        placementId: updatedRow.placementId,
        travelerOptionId: updatedRow.travelerOptionId,
        approvalStatusId: ApprovalStatus[updatedRow.status.replaceAll(/['/.\s]/g, '')],
        acceptanceStatusId: AcceptenceStatus[updatedRow.acceptance],
        effectiveDate: getEndOfDate(updatedRow.effectiveDate),
        userId: employeeId,
        voidStatus: updatedRow.voidStatus === 'N' ? false : true,
        travelerOptionTimestamp: updatedRow.travelerOptionTimestamp,
        assignTaskId: updatedRow.assignTaskId,
        assignRootTaskId: updatedRow.assignRootTaskId,
        travelerOptionTypeId: updatedRow.travelerOptionTypeId
      }));

      dispatch(
        placementModsAction.business_batchUpdatePlacementMod ({
          placementId: updatedRows?.[0]?.placementId,
          modifications
        }),
      );
    }

  }, [rowsToDisplay, appUser, dispatch]);

   const isDateModGreaterThanBooking = (modDetails) => {
      const modName = modDetails?.type?.replaceAll(/['/.\s]/g, '');
      return (modName === 'StartDate' || modName === 'EndDate') && modDetails?.isBookingApprovedOrGreater;
    };
  
    const getReadOnlyStatus = (selectedModsDetails) => {
      const modName = selectedModsDetails?.type?.replaceAll(/['/.\s]/g, '');

      switch (modName) {
        case 'Timeoff':
        case 'Insurance':
        case 'EMILMO':
        case 'Bonus':
          return true;
        
        case 'StartDate':
        case 'EndDate':
          if (!isDateModGreaterThanBooking(selectedModsDetails)) {
            return false;
          }
          
          if (
            selectedModsDetails?.isBookingApprovedOrGreater === false &&
            (selectedModsDetails?.approvalStatusId === ApprovalStatus.Pending ||
              selectedModsDetails?.approvalStatusId === ApprovalStatus.RecruiterApproved)
          ) {
            return false;
          }
          
          if (isDateModGreaterThanBooking(selectedModsDetails)) {
            return true;
          }

          if (
            selectedModsDetails?.isBookingApprovedOrGreater &&
            (selectedModsDetails?.approvalStatusId === ApprovalStatus.Pending ||
              selectedModsDetails?.approvalStatusId === ApprovalStatus.RecruiterApproved)
          ) {
            return false;
          }
          
          return true;
        
        default:          
          if (isDateModGreaterThanBooking(selectedModsDetails)) {
            return true;
          }

          if (
            selectedModsDetails?.isBookingApprovedOrGreater &&
            (selectedModsDetails?.approvalStatusId === ApprovalStatus.Pending ||
              selectedModsDetails?.approvalStatusId === ApprovalStatus.RecruiterApproved)
          ) {
            return false;
          }
          
          return true;
      }
    };

      const isApprovalDisabledWhenLessThanBooking = (currentModDetails) => {
        const modName = currentModDetails?.type?.replaceAll(/['/.\s]/g, '');
        if (currentModDetails?.isBookingApprovedOrGreater === false &&
          currentModDetails?.standard !== 'N' &&
          modName !== 'Bonus'
        ) {
          return true;
        } else if (
          currentModDetails?.isBookingApprovedOrGreater === false &&
          !Authorized(
            [userRoles.candidate_Contracts_Leadership, userRoles.candidate_Contracts_TeamMember],
            appUser?.userInfo,
          ) &&
          (currentModDetails?.approvalStatusId === ApprovalStatus.Approved ||
            currentModDetails?.approvalStatusId === ApprovalStatus.Denied) &&
          modName !== 'BillRate' &&
          modName !== 'BillingShiftDifferential' &&
          modName !== 'Preferences' &&
          modName !== 'Bonus'
        ) {
          return true;
        } else if (
          currentModDetails?.isBookingApprovedOrGreater === false &&
          !isClientContractAdminUser(appUser?.userInfo?.roles || []) &&
          (currentModDetails?.approvalStatusId === ApprovalStatus.Approved ||
            currentModDetails?.approvalStatusId === ApprovalStatus.Denied) &&
          modName === 'BillRate' &&
          modName === 'BillingShiftDifferential' &&
          modName !== 'Preferences' &&
          modName !== 'Bonus'
        ) {
          return true;
        } else {
          return false;
        }
      };

  const getColumnPreferences = (cols: any[]) => {
    try {
      const columnPreferences = gridPreferences?.value;
      if (columnPreferences && columnPreferences.columns) {
        const newColumns = cols.map(column => {
          const foundIndex = columnPreferences.columns.findIndex(item => item?.field === column?.field);
          if (foundIndex !== -1) {
            return {
              ...column,
              ...columnPreferences.columns[foundIndex],
            };
          } else {
            return column;
          }
        });
        return newColumns.sort((a, b) => {
          return (
            columnPreferences.columns.findIndex(i => i.field === a.field) -
            columnPreferences.columns.findIndex(i => i.field === b.field)
          );
        });
      }
      return cols;
    } catch (err) {
      return cols;
    }
  };

  const getVisibilityPreferences = (cols: any) => {
    const columnPreferences = gridPreferences?.value;
    if (columnPreferences && columnPreferences?.columnVisibilityModel) {
      return _.merge(_.cloneDeep(cols), columnPreferences?.columnVisibilityModel);
    }
    return _.cloneDeep(cols);
  };

  const determineVisibilityModel = () => {
    const currentVisibilityModel = getVisibilityPreferences(PendingModificationsVisibilityModel);
    setCurrentColumnVisibilityModel(currentVisibilityModel);
    // Generate base columns without selectedRowDetails to avoid circular dependency
    const baseColumns = pendingModcolumns(onModsDetailsClick, t, []);
    determineGridColumns(baseColumns);
  };

  const determineGridColumns = (cols: any) => {
    const currentGridColumns = getColumnPreferences(cols);
    setColumns(currentGridColumns);
  };

  const determinePinnedColumns = () => {
    if (gridPreferences?.value?.pinnedColumns) {
      setPinnedColumns(gridPreferences?.value?.pinnedColumns);
    }
  };

  const determineFilters = () => {
    if (gridPreferences?.value?.updatedFilter) {
      setFilterModel(gridPreferences?.value?.updatedFilter);
    }
  };

  const determineDensity = () => {
    if (gridPreferences?.value?.gridDensity) {
      setDensity(gridPreferences?.value?.gridDensity);
    }
  };
  
  const saveSortModel = useSortModelPreference({
    gridTag,
    gridPreferences,
    setShowResetButton,
  });

  const getSortModelPreferences = useGetSortModelPreferences({
    gridPreferences,
  });

  const determineSortModel = React.useCallback(() => {
    const currentGridSortModel = getSortModelPreferences(sortedColumn ?? []);
    setSortedColumn(currentGridSortModel);
  }, [getSortModelPreferences, sortedColumn]);

  const hasNonDefaultGridPreferences = React.useCallback(() => {
    const value = gridPreferences?.value;
    if (!value) {
      return false;
    }

    const savedColumns = new CurrentGridColumns(value.columns, value.columnVisibilityModel);
    const defaultColumns = new CurrentGridColumns(
      pendingModcolumns(onModsDetailsClick, t, []),
      _.cloneDeep(PendingModificationsVisibilityModel),
    );

    return (
      (value.columns?.length > 0 && !savedColumns.isEqual(defaultColumns.columns)) ||
      (value.columnVisibilityModel && !_.isEqual(value.columnVisibilityModel, _.cloneDeep(PendingModificationsVisibilityModel))) ||
      !_.isEmpty(value.pinnedColumns) ||
      (value.updatedFilter?.items?.length ?? 0) > 0 ||
      (value.gridDensity && value.gridDensity !== 'compact') ||
      Boolean(value.sortedColumn) ||
      (value.multiSortedColumns?.length ?? 0) > 0
    );
  }, [gridPreferences?.value, onModsDetailsClick, t]);

  const savePreferences = React.useCallback(
    ({
      field,
      columns: gridColumns,
      visibilityModel,
    }: {
      field?: string;
      columns: XGridColumns;
      visibilityModel: GridColumnVisibilityModel;
    }) => {
      if (!columns || columns.length === 0) {
        return;
      }
      
      const currentGridColumns = new CurrentGridColumns(gridColumns).columns;

      if (currentGridColumns && currentGridColumns.length > 0 && currentGridColumns[0].field === '__check__')
        currentGridColumns.shift();

      const comparableColumns = new CurrentGridColumns(
        gridPreferences?.value?.columns,
        gridPreferences?.value?.columnVisibilityModel,
      );
      const columnsEqual = comparableColumns.isEqual(currentGridColumns);
      const visibilityEqual = comparableColumns.isVisibilityModelEqual(visibilityModel);

      if (!columnsEqual || !visibilityEqual) {
        const preferenceData = {
          id: gridTag,
          value: {
            ...(gridPreferences?.value || {}),
            columns: currentGridColumns,
            columnVisibilityModel: visibilityModel,
          },
        };
        setShowResetButton(true);
        dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
      }
    },
    [columns, gridPreferences?.value, dispatch],
  );

  const handlePinnedColumnsChange = usePinnedColumnsPreference({
    gridTag,
    gridPreferences,
    setPinnedColumns,
    setShowResetButton,
  });

  const saveFilterPreference = React.useCallback(
    (model: GridFilterModel) => {
      setFilterModel(model);
      const preferenceData = {
        id: gridTag,
        value: {
          ...(gridPreferences?.value || {}),
          updatedFilter: model,
        },
      };
      setShowResetButton(true);
      dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
    },
    [filterModel, userPreference.loaded, gridPreferences?.value, dispatch],
  );

  React.useEffect(() => {
    if (userPreference?.loaded && gridPreferences) {
      determineVisibilityModel();
      determinePinnedColumns();
      determineFilters();
      determineDensity();
      
      const savedModel = getSortModelPreferences([]);
      if (savedModel?.length > 0) {
        setSortedColumn(savedModel);
      } else {
        determineSortModel();
      }
      setShowResetButton(hasNonDefaultGridPreferences());
    }
  }, [userPreference?.loaded, gridPreferences, hasNonDefaultGridPreferences]);

  return (
    <Box>
      <XGridInlineEdit
        gridTag={gridTag}
        onStateChange={(state) => {
          filterRowCount(state);
          // handle density changes
          if (state.density?.value !== density) {
            setDensity(state.density.value);
            const preferenceData = {
              id: gridTag,
              value: {
                ...(gridPreferences?.value || {}),
                gridDensity: state.density.value,
              },
            };
            setShowResetButton(true);
            dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
          }
        }}
        disableMultipleColumnsSorting={false}
        columns={columns}
        rows={rowsToDisplay}
        onSave={handleSaveChanges}
        onCancel={handleCancelChanges}
        saving={isSavingInProgress}
        getRowClassName={getRowClassName}
        isCellEditable={(params) => {
          // Disable editing when saving is in progress or no rows selected
          if (isSavingInProgress) return false;
          
          switch (params.field) {
            case 'effectiveDate':
              return isCellEditable(params, 'effectiveDate');
            case 'acceptance':
              return isCellEditable(params, 'acceptanceStatus');
            case 'status':
              return isCellEditable(params, 'approvalStatus');
            default:
              return false;
          }
        }}
        sx={{
          minHeight: `${xgridMinHeight}px`,
          height: `${gridHeight}px`,
          '& .MuiDataGrid-virtualScroller': {
            height: rowsToDisplay.length >= maxCount ? '' : rowsToDisplay.length === 0 ? '117px' : 'auto !important',
          },
        }}
        height={gridHeight}
        headerHeight={headerHeight}
        title={t('placement.placementMods.pendingMods.title')}
        checkboxSelection
        pagination={false}
        className={classes.grid}
        hideFooter
        keepNonExistentRowsSelected={true}
        onSelectionModelChange={ids => onRowsSelectionHandler(ids)}
        onSortModelChange={sortChangeHandelr}
        sortingMode="client"
        sortModel={sortedColumn}
        rowCount={totalCount}
        disableSelectionOnClick={true}
        rowCountDisplay={totalCount}
        loading={isCallingAPI}
        columnVisibilityModel={currentColumnVisibilityModel}
        onColumnVisibilityModelChange={(model, details) => {
          const nextVisibilityModel = _.cloneDeep(model);
          if (expectedResetVisibilityModelRef.current) {
            if (_.isEqual(nextVisibilityModel, expectedResetVisibilityModelRef.current)) {
              expectedResetVisibilityModelRef.current = null;
              setCurrentColumnVisibilityModel(nextVisibilityModel);
              return;
            }
          }
          if (_.isEqual(nextVisibilityModel, currentColumnVisibilityModel)) {
            return;
          }
          setCurrentColumnVisibilityModel(nextVisibilityModel);
          savePreferences({
            field: undefined,
            columns: _.cloneDeep(columns),
            visibilityModel: nextVisibilityModel,
          });
        }}
        onColumnResizeStop={_columns => {
          savePreferences({
            field: undefined,
            columns: _columns,
            visibilityModel: _.cloneDeep(currentColumnVisibilityModel),
          });
        }}
        onColumnOrderChange={(params, event, details, _columns) => {
          savePreferences({
            field: params.field,
            columns: _columns,
            visibilityModel: _.cloneDeep(currentColumnVisibilityModel),
          });
        }}
        pinnedColumns={pinnedColumns}
        onPinnedColumnsChange={handlePinnedColumnsChange}
        filterModel={filterModel}
        onFilterModelChange={saveFilterPreference}
        density={density}
        toolbarProps={{
          rightActions,
          leftActions,
          refreshButton: true,
          resetButton: showResetButton,
          resetColumns: () => {
            const defaultColumns = pendingModcolumns(onModsDetailsClick, t, []);
            const defaultVisibilityModel = _.cloneDeep(PendingModificationsVisibilityModel);
            expectedResetVisibilityModelRef.current = defaultVisibilityModel;
            setColumns(defaultColumns);
            setCurrentColumnVisibilityModel(defaultVisibilityModel);
            setPinnedColumns({});
            setFilterModel({ items: [] });
            setDensity('compact');
            setSortedColumn([]);
            setShowResetButton(false);
            // clear preferences
            const preferenceData = {
              id: gridTag,
              value: {
                columns: defaultColumns,
                columnVisibilityModel: defaultVisibilityModel,
                pinnedColumns: {},
                gridDensity: 'compact',
                updatedFilter: { items: [] },
              },
            };
            dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
          },
          refreshGrid: refreshGrid,
        }}
      />
      <Popover
        open={Boolean(optionMenuAncorEl)}
        anchorEl={optionMenuAncorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        style={{ zIndex: '9999', marginLeft: '-252px', marginTop: '2px', maxHeight: `${popoverHeight}px` }}
      >
        <ClickAwayListener onClickAway={handleAddClose}>
          <Paper className={classes.paper}>{optionsList}</Paper>
        </ClickAwayListener>
      </Popover>
      <Popper
        open={Boolean(refreshOptsAnchorEl)}
        anchorEl={refreshOptsAnchorEl}
        placement={'bottom-end'}
        style={{ zIndex: '999' }}
      >
        <ClickAwayListener onClickAway={handleAddClose}>
          <Paper className={`${classes.paper} ${classes.popperPaper}`}>{refreshOptionsList}</Paper>
        </ClickAwayListener>
      </Popper>
      {openTaskGrid && (
        <LinkTaskForMods
          openTaskGrid={openTaskGrid}
          setOpenTaskGrid={setOpenTaskGrid}
          selectedRowDetails={selectedRowDetails}
          setSelectedRowDetails={setSelectedRowDetails}
        />
      )}
      <ReplaceTasks
        openDialog={openReplaceTasks}
        handleConfirmAction={() => {
          setOpenTaskGrid(true);
          setOpenReplaceTasks(false);
        }}
        handleCancelAction={() => {
          setOpenReplaceTasks(false);
        }}
      />
      <UnLinkTasks
        openDialog={openUnlink}
        handleConfirmAction={() => {
          saveUnlinkMods();
          setOpenUnlink(false);
        }}
        handleCancelAction={() => {
          setOpenUnlink(false);
        }}
      />
      <UnableRefresh
        openDialog={openRefreshDialog}
        dialogContent={refreshModMessage}
        handleCancelAction={() => {
          dispatch(placementModsAction.setCloseRefreshModDetails());
        }}
      />
      <GenericDialog
        open={openRefreshContractPayrollDialog}
        maxWidth="sm"
        dialogTitleProps={{
          text: t('unableRefreshModal.unableRefresh'),
          closeButton: true
        }}
        onClose={handleCloseRefreshContractPayrollDialog}
        dialogActions={[
          {
            text: t('unableRefreshModal.confirmation.ok'),
            onClick: handleCloseRefreshContractPayrollDialog,
            variant: 'contained',
          },
        ]}
        dialogContentProps={{
          content: t('placement.placementMods.pendingMods.refreshContractPayrollModal.noNewContractPayroll'),
          variant: 'text'
        }}
      />
      <RefreshContractPayrollModal
        openDialog={openRefreshContractPayrollConfirmDialog}
        handleCancelAction={handleCloseRefreshContractPayrollConfirmDialog}
        handleConfirmAction={handleConfirmRefreshContractPayroll}
      />
    </Box>
  );
};

export default PendingModifications;

const getAcceptanceStatusOptions = (acceptanceStatusOptions: [{key: number, value: string}]) => {
  let acceptanceOptions = ['Accepted', 'Declined'];

  if (acceptanceStatusOptions) {
    acceptanceOptions = acceptanceStatusOptions.map(option => option.value);
  }

  return acceptanceOptions;
}

const pendingModcolumns = (onModsDetailsClick, t, selectedRowDetails): GridColumns => [
  {
    ...XGridDefaultColumn,
    field: 'type',
    headerName: t('placement.placementMods.pendingMods.gridColumns.type'),
    flex: 0,
    width: 125,
    renderCell: XGridOverflowCell(XGridClickableCell(onModsDetailsClick, true))(XGridClickableCell(onModsDetailsClick)),
  },
  {
    ...XGridDefaultColumn,
    field: 'description',
    headerName: t('placement.placementMods.pendingMods.gridColumns.description'),
    flex: 0,
    width: 178,
  },
  {
    ...XGridDefaultColumn,
    field: 'standard',
    headerName: t('placement.placementMods.pendingMods.gridColumns.standard'),
    flex: 0,
    width: 100,
  },
  {
    ...XGridDefaultColumn,
    field: 'amount',
    headerName: t('placement.placementMods.pendingMods.gridColumns.amount'),
    flex: 0,
    width: 100,
    align: 'right',
    renderCell: params => {
      return getAmount(params?.value);
    },
  },
  {
    ...XGridDefaultColumn,
    field: 'acceptance',
    headerName: t('placement.placementMods.pendingMods.gridColumns.acceptance'),
    flex: 0,
    width: 100,
    editable: true,
    type: 'singleSelect',
    valueOptions: params => {
      return getAcceptanceStatusOptions(params.row.acceptanceOptions)
    },
  },
  {
    ...XGridDefaultColumn,
    field: 'effectiveDate',
    headerName: t('placement.placementMods.pendingMods.gridColumns.effectiveDate'),
    flex: 0,
    width: 120,
    editable: true,
    type: 'date',
    valueSetter: (params: GridValueSetterParams) => {
      // Convert the date value to formatted string for saving
      let formattedDate = missingField;
      if (params.value) {
        // If it's already a date string, convert to Date then format
        const dateObj = typeof params.value === 'string' ? new Date(params.value) : params.value;
        formattedDate = formatDate(dateObj);
      }
      return { ...params.row, effectiveDate: formattedDate };
    },
    valueFormatter: (params) => {
      // Format the ISO date string for display
      if (params.value && params.value !== null) {
        return formatDate(new Date(params.value));
      }
      return missingField;
    },
  },
  {
    ...XGridDefaultColumn,
    field: 'status',
    headerName: t('placement.placementMods.pendingMods.gridColumns.status'),
    flex: 0,
    width: 150,
    editable: true,
    type: 'singleSelect',
    valueOptions: params => {
      const selectRowDetail = selectedRowDetails.find(row => row.id === params.id);

      return (selectRowDetail?.approvalStatusOptions ?? []);
    },
    renderCell: XGridChipCell({
      size: 'small',
      dynamicColor: (params: GridCellParams) => {
        return getColor(params.value);
      },
      renderValue: (params: GridCellParams) => {
        return params.value;
      },
    }),
  },
  {
    ...XGridDefaultColumn,
    field: 'task',
    headerName: t('placement.placementMods.pendingMods.gridColumns.task'),
    flex: 0,
    width: 60,
    renderCell: params => <XGridTaskCell hasTask={params.value} params={params} />,
  },
  {
    ...XGridDefaultColumn,
    field: 'recruiterApproved',
    headerName: t('placement.placementMods.pendingMods.gridColumns.recruiterApproved'),
    flex: 0,
    width: 163,
  },
  {
    ...XGridDefaultColumn,
    field: 'byRecruiter',
    headerName: t('placement.placementMods.pendingMods.gridColumns.byRecruiter'),
    flex: 0,
    width: 110,
  },
  {
    ...XGridDefaultColumn,
    field: 'lastUpdated',
    headerName: t('placement.placementMods.pendingMods.gridColumns.lastUpdated'),
    minWidth: 170,
    renderCell: (params: any) => `${formatDate(params.row.lastUpdated, 'dateAnd12HourTime')}`,
  },
];